import React, { Component } from "react";
import { connect } from "react-redux";
import { compose, bindActionCreators } from "redux";
import EmailComponent from "../components/AlertPreferences/DeliveryMethods/email";
import "bootstrap/dist/css/bootstrap.min.css";
import PushNotificationComponent from "../components/AlertPreferences/DeliveryMethods/pushnotification";
import TextMessageComponent from "../components/AlertPreferences/DeliveryMethods/textmessage";
import { withRouter } from "react-router-dom";
import "../components/AlertPreferences/DeliveryMethods/deliveryMethod.css";
import { Button } from 'react-bootstrap';
import {
  bankingAlerts,
  accountAlerts,
  triggerVerificationCode,
  submitVerificationCode,
  saveAndVerifyDeliveryMethod,
  deleteDeliveryAddress,
  deletePhoneNumber,
  addBankingAlertValue,
  updateBankingAlertValues,
  addDeliveryMethod,
  addPhoneNumber,
  addCurrentOperatingValue
} from "../actions/actions";
import FooterComponent from "../Shared/footer";
import _ from "lodash";
import { LoadingState } from "../helpers/enum";
import Modal from "react-modal";

import BackButton from '../Shared/BackButton';
import { Header, LoadingMask } from '../Shared';
import { isMobile } from '../helpers/utils';

class DeliveryMethod extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showDeleteConfirmation: false
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillMount() {
    if (this.props.loadingState !== LoadingState.FULFILLED) {
      this.props.bankingAlerts();
      this.props.accountAlerts();
    }
  }

  componentDidUpdate(){
    setTimeout(() => {
    var root = document.getElementById("root");
   
    var _event = {};

    _event = {
    name: 'END_SETTING_HEIGHT',
    height: root.parentElement.parentElement.offsetHeight
};

  //Post END Height Event for OLB 
    window.parent.postMessage(_event, '*')
    }, 
  0)    
};

  showDeleteConfirmation = (title, onSuccess) => {
    this.setState({
      deleteTitle: title,
      deleteConfirmation: onSuccess,
      showDeleteConfirmation: true
    });
  };
  render() {
    const { deliveryMethodItem , loadingState, accountAlertState} = this.props;

    if(loadingState === LoadingState.PENDING || accountAlertState === LoadingState.PENDING){
      return <LoadingMask ctrlCss="fullpage" NavigationLink={``} />
    }

    if (!deliveryMethodItem) {
      return null;
    }
    const textItems = this.props.deliveryAddresses.filter(
      s => s.channel === "SMS"
    );

    const emailItems = this.props.deliveryAddresses.filter(
      s => s.channel === "Email"
    );
    
    const pushItems = this.props.deliveryAddresses.filter(
      s => s.channel === "Push"
    );

    const customStyles = {
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '45%',
        minWidth: '30%',
        padding: '2%'
      }
    };
    return (
      <div>
            <div aria-live="polite">
        {this.props.deliveryMethodState === LoadingState.PENDING && <LoadingMask ctrlCss="overlay" NavigationLink={``} />}
        </div>
        <div className={isMobile() ? `mobilecontainer-box` : `container-box`} >

          <BackButton
            href="#/landingPage"
            text="Alerts"
          />
          <Header
            mainHeading={"Delivery Methods"}
            subHeading={"Add & Edit your Delivery Methods"}
            subHeadingDesc={"Each new email address, device and phone number will be verified to ensure the security of your account information."}
            subHeadingPres={"When you edit a previously verified email address or phone number, all alerts associated with it will be disabled until the new address is verified."}
          />
          <div id="content">
            
            <PushNotificationComponent
              items={pushItems}
              name="Push Notification"
              updateBankingAlertValues={this.props.updateBankingAlertValues}
              addBankingAlertValue={this.props.addBankingAlertValue}
              deliveryEditItem={this.props.deliveryEditItem}
              deliveryAddItem={this.props.deliveryAddItem}
            />

            <EmailComponent className="deliveryMethod-title"
              items={emailItems}
              name={"Email"}
              submitVerificationCode={this.props.submitVerificationCode}
              history={this.props.history}
              saveAndVerifyDeliveryMethod={this.props.saveAndVerifyDeliveryMethod}
              triggerVerificationCode={this.props.triggerVerificationCode}
              deleteDeliveryAddress={this.props.deleteDeliveryAddress}
              displayheadertext={"Email Address"}
              buttontext={"Save & Verify"}
              updateBankingAlertValues={this.props.updateBankingAlertValues}
              addBankingAlertValue={this.props.addBankingAlertValue}
              deliveryEditItem={this.props.deliveryEditItem}
              deliveryAddItem={this.props.deliveryAddItem}
              addDeliveryMethod={this.props.addDeliveryMethod}
              showDeleteConfirmation={this.showDeleteConfirmation}
              addCurrentOperatingValue={this.props.addCurrentOperatingValue}
            />

            <TextMessageComponent className="deliveryMethod-title"
              items={textItems}
              name={"Text Message"}
              displayheadertext={"Phone Number"}
              triggerVerificationCode={this.props.triggerVerificationCode}
              submitVerificationCode={this.props.submitVerificationCode}
              deletePhoneNumber={this.props.deletePhoneNumber}
              buttontext={"Save & Verify"}
              updateBankingAlertValues={this.props.updateBankingAlertValues}
              addBankingAlertValue={this.props.addBankingAlertValue}
              deliveryEditItem={this.props.deliveryEditItem}
              showDeleteConfirmation={this.showDeleteConfirmation}
              deliveryAddItem={this.props.deliveryAddItem}
              addPhoneNumber={this.props.addPhoneNumber}
              history={this.props.history}
              addCurrentOperatingValue={this.props.addCurrentOperatingValue}
              saveAndVerifyDeliveryMethod={this.props.saveAndVerifyDeliveryMethod}
            />

            <Modal
              style={customStyles}
              ariaHideApp={false}
              isOpen={this.state.showDeleteConfirmation}
              onRequestClose={() => {
                this.setState({ showDeleteConfirmation: false });
              }}
              contentLabel="Example Modal"
            >
              <div className="Row">
                <div className="Col" md="12">
                  {this.state.deleteTitle}
                </div>
              </div>
              <hr></hr>
              <div className="Row">
                <div className="Col alignDeletePopUp" md="12">

                  <Button
                    variant="Link"
                    className="AppLink colleftalign"
                    onClick={() => {
                      this.setState({
                        showDeleteConfirmation: false
                      });
                    }}
                  >
                    Cancel
                </Button>
                  <Button
                    className="colrightalign custom-buttonForDeletePopUp"
                    onClick={() => {
                      this.state.deleteConfirmation();
                      this.props.updateBankingAlertValues({
                        currentEditItemId: "",
                        currentEditItemType: "",
                        currentEditItemValue: ""
                      });

                      this.setState({
                        showDeleteConfirmation: false
                      });
                    }}
                  >
                    Continue
                </Button>
                </div>
              </div>
            </Modal>
            <FooterComponent> </FooterComponent>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  deliveryMethodItem: state.bankingAlertsReducer.items,
  deliveryEditItem: state.bankingAlertsReducer.editItem,
  deliveryAddItem: state.bankingAlertsReducer.addItem,
  loadingState: state.bankingAlertsReducer.loadingState,
  accountAlertState : state.accountAlertsReducer.loadingState,
  deliveryMethodState: state.accountAlertsReducer.deliveryMethodState,
  deliveryAddresses: _.get(
    state.accountAlertsReducer,
    "items.deliveryMethods",
    []
  )
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      accountAlerts,
      bankingAlerts,
      triggerVerificationCode,
      submitVerificationCode,
      saveAndVerifyDeliveryMethod,
      deleteDeliveryAddress,
      deletePhoneNumber,
      addBankingAlertValue,
      updateBankingAlertValues,
      addDeliveryMethod,
      addPhoneNumber,
      addCurrentOperatingValue
    },
    dispatch
  );
};
export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(DeliveryMethod);
